import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ExitNote, ExitNoteDetail } from 'src/app/models/exit-note.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExitNoteService } from 'src/app/services/exit-note.service';

@Component({
  selector: 'app-exit-note-details',
  templateUrl: './exit-note-details.component.html',
  styleUrls: ['./exit-note-details.component.scss']
})
export class ExitNoteDetailsComponent {
  @Input() noteId: number;
  @Input() note: ExitNote;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;

  exitNoteDetails: ExitNoteDetail[] = [];
  exitNoteData: ExitNote = null;

  constructor(
    private toastService: ToastrService,
    private exitNoteService: ExitNoteService
  ) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (!this.noteId) {
      return;
    }
    this.exitNoteService.getExitNoteById(this.noteId).subscribe({
      next: (response: ResponseObject) => {
        this.exitNoteData = response.data;
        this.exitNoteDetails = response.data.details;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener los detalles de la nota de entrada", "Error");
      }
    });
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(false);
  }

  closedCreateNote() {
    this.closed.emit(false);
    this.showModal = false;
  }

}
